import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { BaseIncidentFields } from './common';

export enum PetsInformation {
  YES = 'YES',
  NO = 'NO',
  UNKNOWN = 'UNKNOWN',
}

export enum ApartmentAccessMethod {
  AGREE_ON_TIME = 'AGREE_ON_TIME',
  OK = 'OK',
}

export interface DefectIncidentRequest extends BaseIncidentFields {
  title?: string;
  description?: string;
  access: ApartmentAccessMethod;
  pets: PetsInformation;
  info?: string;
  classification: IncidentClassification;
  subClassification: IncidentSubClassification;
}
